import { isEmptyObject } from "../../../utils/tests";
import { LmpHeroQuery, LmpHeroSubscription } from '../types';

/**
 * typeguard for LmpHeroQuery
 * @param obj LmpHeroQuery object passed to transformer
 */

export const isValidLmpHeroQuery = (obj: LmpHeroQuery): boolean => Boolean(obj?.data?.getLmpHero && !isEmptyObject(obj.data.getLmpHero));

/**
 * typeguard for LmpHeroSubscription
 * @param obj LmpHeroSubscription object passed to transformer
 */

export const isValidLmpHeroSubscription = (obj: LmpHeroSubscription): boolean => Boolean(obj?.data?.onUpdateLmpHeroByMatchId && !isEmptyObject(obj.data.onUpdateLmpHeroByMatchId));

